// extracted by css-extract-rspack-plugin
export default {"link":"_8e49b1c9"};